export default __webpack_public_path__ + "static/media/boost_logo.892f398a.svg";